import classNames from "classnames";
import React from "react";

interface ExtendedIconProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
}

const ExtendedIcon = ({ className, ...props }: ExtendedIconProps) => {
  return <i {...props} className={classNames("fas fa-splotch text-orange", className)} />;
};

export default ExtendedIcon;
